import { render, staticRenderFns } from "./FileBase64.vue?vue&type=template&id=255b86a7"
import script from "./FileBase64.vue?vue&type=script&lang=js"
export * from "./FileBase64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports